import { SET_FEEDBACK } from './actionTypes';
import { IGetRequestResponse } from '../../components/FeedbackForm/FeedbackForm.d';

export const setFeedback = (response: IGetRequestResponse) => {
    return {
        type: SET_FEEDBACK,
        payload: response,
    };
};
